<template>
  <div style="z-index:500000">
      <ui-modal-old name="create-project-modal">
        <template v-slot:icon>
          <i class="fas fa-folder-open"></i>
        </template>
        <template v-slot:title>Create A Project</template>

        <template v-slot:main>
          <crud-errors :errors="errors"></crud-errors>

          <dl>
            <dt>Title</dt>
            <dd><input type="text" v-model="new_item.title"/></dd>
          </dl>
          <hr class="mb-6 mt-8"/>
          <heading size="medium">Packages Belonging To This Project</heading>
          <dl>
            <dt>Choose Packages</dt>
            <dd>
              <v-select v-model="new_item.packages_dd" :on-search="getPackages"
                        :options="packages"
                        multiple
                        placeholder="Associate With A Package...">
                <span slot="no-options">Start typing to find packages.</span>
              </v-select>
            </dd>
          </dl>

        </template>
        <template v-slot:buttons>
          <ui-button class="sm:ml-2" colour="green" @click.prevent="addItem()">
            <i class="fas fa-plus-circle mr-1"></i> Create Project
          </ui-button>
        </template>
      </ui-modal-old>
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from 'vue-flatpickr-component';

export default {
  components: {flatPickr, vSelect},
  props: ['afterCreationUrl'],
  data() {
    return {
      name: 'project',
      new_item: {},
      packages: [],
      errors: null
    }
  },
  methods: {
    openModal() {
      this.new_item = {};
      this.resetErrors();
      window.eventBus.$emit('modal-open-create-project-modal');
    },
    closeModal() {
      window.eventBus.$emit('modal-close-create-project-modal');
      this.new_item = {};
      this.resetErrors();
    },
    getPackages: _.debounce(function (search, loading) {
      if (!search) {
        return;
      }

      var that = this;
      loading(true);
      that.packages = [];
      axios.get(appUrls.packages.index, {params: {'compacted': true, 'search': search}})
          .then(response => {
            _.forEach(response.data.data, function (package_) {
              that.packages.push({
                label: package_.name,
                value: package_.id
              });
            });
            loading(false);
          });
    }, 500),
            resetErrors() {
                window.eventBus.$emit('crud-errors-dismissed');
            },
            addItem() {
                var that = this;
                var data = $.extend({}, this.new_item);

                if (_.isObject(data.packages_dd)) {
                    data.packages = [];
                    _.forEach(data.packages_dd, function (packageInfo) {
                        data.packages.push(packageInfo.value);
                    });
                }

                delete data['packages_dd'];

                axios.request({
                    method: 'post',
                    url: appUrls.projects.store,
                    data: data,
                    config: {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                }).then(response => {
                  window.eventBus.$emit('project-created', response.data.data);

                  that.closeModal();
                    if (that.afterCreationUrl) {
                        window.location.href = that.afterCreationUrl;
                    }
                }).catch(function (error) {
                    if (error.response.status === 422) {
                        that.errors = error.response.data.errors;
                    }
                });
            },
            backToNav: function () {
                window.eventBus.$emit('crud-back-to-nav-' + this.name);
            }
        },
        mounted() {
          var that = this;

          window.eventBus.$on('create-new-project', function () {
            that.openModal();
          });

          window.eventBus.$on('crud-errors-dismissed', function () {
            that.errors = null;
          });
        }
    }
</script>
